import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import {
    getAllProducts,
    resetQuestionnaire,
} from '../../redux/actions';
import Loader from '../../atoms/Loader';
import AllProducts from '../../molecules/AllProducts';
import FooterNav from '../../molecules/FooterNav';
import { tealiumConfiguration } from '../../config';
import { productID } from '../../constants';
import {
    getResultsReportingData,
    dispatchReportingEvent,
    mapTealiumRecommendations,
    tealiumUpdatedPageView,
    tealiumUpdatedClick,
} from '../../utils';

function AllProductsPage() {
    const history = useHistory();
    const dispatch = useDispatch();

    const error = useSelector((state) => state.errorReducer.error);
    const recommendations = useSelector(
        (state) => state.resultsReducer.allProducts,
    );
    const recommendationsLoaded = useSelector(
        (state) => state.resultsReducer.allProductsLoaded,
    );
    const sessionID = useSelector(
        (state) => state.questionnaireReducer.sessionID,
    );
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );
    const isLoading = useSelector(
        (state) => state.loaderReducer.isLoading,
    );

    function goBack() {
        history.goBack();
    }

    function buttonCallback(action, product) {
        if (window.reportingData) {
            const reportingData = JSON.parse(
                JSON.stringify(window.reportingData),
            );
            reportingData.onClickEvent = action.toLowerCase();
            reportingData.productsRecommended = product.toLowerCase();
            dispatchReportingEvent(reportingData);
            tealiumUpdatedClick();
        }
    }

    function restartRecommender() {
        dispatch(resetQuestionnaire());
    }

    useEffect(() => {
        if (recommendations.length < 1) {
            dispatch(getAllProducts(productID));
        }
    }, []);

    useEffect(() => {
        if (recommendationsLoaded) {
            const tealiumConfig = tealiumConfiguration[productID];
            const { siteSection, subSiteSection } = tealiumConfig;

            const currentPage =
                AEMContent.allProductsPage.title.toLowerCase();

            const reportingData = getResultsReportingData(
                currentPage,
                siteSection,
                subSiteSection,
                mapTealiumRecommendations(recommendations),
            );
            dispatchReportingEvent(reportingData);
            tealiumUpdatedPageView();

            window.scrollTo(0, 0);
        }
    }, [recommendationsLoaded]);

    useEffect(() => {
        if (!sessionID) {
            history.push('/start');
        }
    }, [sessionID]);

    useEffect(() => {
        if (error) {
            history.push('/tech-trouble');
        }
    }, [error]);

    return (
        <>
            {isLoading && <Loader />}
            <Header title={AEMContent.header.fullName} />
            <Helmet>
                <title>
                    Result show all | Product recommender | U.S. Bank
                </title>
            </Helmet>
            <main id="app__content">
                <AllProducts
                    buttonCallback={buttonCallback}
                    title={AEMContent.allProductsPage.title}
                    content={AEMContent.allProductsPage.content}
                    imageUrl={AEMContent.allProductsPage.imageUrl}
                    recommendations={recommendations}
                    goBack={goBack}
                    restartRecommender={restartRecommender}
                />
            </main>
            <FooterNav
                allProducts="true"
                link={AEMContent.backButtonLink}
                text={AEMContent.backButtonText}
            />
            <Footer
                header={AEMContent.footer.connectionTitle}
                content={AEMContent.footer.footerDisclosure}
                privacyLabel={AEMContent.footer.privacyLabel}
                privacyUrl={AEMContent.footer.privacyUrl}
                fdic={AEMContent.footer.connectionContent}
                cobrowseLabel={AEMContent.footer.cobrowseLabel}
                cobrowseUrl={AEMContent.footer.cobrowseUrl}
            />
        </>
    );
}

export default AllProductsPage;
